type TimeSpentFieldValue = {
	timeSpent: string | null;
	started?: string | null;
	comment?: string | null;
};

function isTimeSpentField(value: unknown): value is TimeSpentFieldValue {
	const validKeys = new Set(['timeSpent', 'started', 'comment']);
	return (
		typeof value === 'object' &&
		value !== null &&
		'timeSpent' in value &&
		Object.keys(value).every((key) => validKeys.has(key))
	);
}

export function toTimeSpentFieldValue(value: unknown): TimeSpentFieldValue | undefined {
	return isTimeSpentField(value) ? value : undefined;
}
